import React, { useEffect, useState } from "react";
import api from "@/lib/api";

// Live period progress: Homebase hours only (owner rule: no tier, gap, pace or projection).
export default function PeriodProgress() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/employee/progress")
      .then(({ data: d }) => { if (!cancelled) setData(d); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!data || !data.available) return null;

  const daysText = data.period?.days_text;
  return (
    <div className="eh-card" style={{ animationDelay: "0.2s" }} data-testid="period-progress-card">
      <div className="eh-arc-eyebrow" style={{ marginBottom: 6 }}>This period so far</div>
      <div data-testid="progress-lead" style={{ fontFamily: "Cormorant, serif", fontSize: 38, color: "#231E1A", lineHeight: 1.1 }}>
        {data.hours} hour{data.hours !== 1 ? "s" : ""} so far
      </div>
      {data.variant === "contractor" && data.contractor_note && (
        <div style={{ marginTop: 10, fontSize: 13, fontStyle: "italic", color: "#8A7355" }} data-testid="progress-contractor-note">{data.contractor_note}</div>
      )}
      {data.hours_contains_projection && (
        <div style={{ marginTop: 8, fontSize: 12, color: "#A89A88" }} data-testid="progress-projection-note">contains a projection</div>
      )}
      {daysText && (
        <div style={{ marginTop: 12, display: "inline-block", fontSize: 12, color: "#8A7355", background: "#F3EEE7", borderRadius: 999, padding: "3px 10px" }} data-testid="progress-days-chip">
          {daysText}
        </div>
      )}
      {data.freshness && (
        <div style={{ marginTop: 8, fontSize: 11, color: "#B3A798" }} data-testid="progress-freshness">{data.freshness.text}</div>
      )}
    </div>
  );
}
